import script from "./MobileMall.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobileMall.vue?vue&type=script&lang=ts&setup=true"

import "./MobileMall.vue?vue&type=style&index=0&id=7906cc67&lang=scss&scoped=true"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7906cc67"]])

export default __exports__